<template >
  <div class="new-life">
    <my-scroll class="scroll">
      <div class="scroll-content">
        <header>ນະໂຍບາຍຄວາມເປັນສ່ວນຕົວ</header>
        <div class="letter"
             style="text-indent:2em">
          ຫວັງວ່າທ່ານຈະອ່ານ "ນະໂຍບາຍຄວາມເປັນສ່ວນຕົວ" ຢ່າງລະອຽດ ແລະ ຮຽນຮູ້ເພີ່ມເຕີມກ່ຽວກັບວິທີເກັບກໍາ ແລະ ນໍາໃຊ້ຂໍ້ມູນ, ເພື່ອໃຫ້ທ່ານສາມາດເຂົ້າໃຈການບໍລິການຂອງພວກເຮົາໄດ້ດີຂຶ້ນ ແລະ ຕັດສິນໃຈເລືອກຢ່າງເໝາະສົມ.
        </div>
        <div class="letter"
             style="text-indent:2em">
          GoLaos ແມ່ນການສະໜອງຜະລິດຕະພັນ ແລະ ການບໍລິການໂດຍບໍລິສັດ NewLife Electronic Commerce Company Limited ຫາກນຳໃຊ້ GoLaos APP, ສະແດງວ່າທ່ານເຫັນດີຕໍ່ກັບເນື້ອໃນນະໂຍບາຍຂອງພວກເຮົາ.
        </div>
        <div class="letter"
             style="text-indent:2em">
          GoLaos ໄດ້ເຄົາລົບ ແລະ ປົກປ້ອງຄວາມສ່ວນຕົວຂອງຜູ້ໃຊ້ບໍລິການທັງໝົດ, ເພື່ອສະໜອງການບໍລິການທີ່ຖືກຕ້ອງ ແລະ ເປັນສ່ວນບຸກຄົນຫຼາຍຂື້ນ, GoLaos ຈະນໍາໃຊ້ ແລະ ເປີດເຜີຍຂໍ້ມູນສ່ວນຕົວຂອງທ່ານ ໂດຍອີງຕາມນະໂຍບາຍຄວາມເປັນສ່ວນຕົວສະບັບນີ້, ເຖິງຢ່າງໃດກໍ່ຕາມ GoLaos ຈະປະຕິບັດຕໍ່ຂໍ້ມູນນີ້ດ້ວຍຄວາມເອົາໃຈໃສ່ ແລະ ຮອບຄອບຢ່າງສູງ. ຍົກເວັ້ນຕາມທີ່ໄດ້ກຳນົດໄວ້ໃນນະໂຍບາຍຄວາມເປັນສ່ວນຕົວນີ້ໄດ້ກໍານົດເປັນຢ່າງອື່ນ. GoLaos ຈະບໍ່ເປີດເຜີຍ ຫຼື ໃຫ້ຂໍ້ມູນກັບບຸກຄົນທີສາມໂດຍບໍ່ໄດ້ຮັບອະນຸຍາດຈາກທ່ານ, ທາງ GoLaos ຈະປັບປຸງນະໂຍບາຍຄວາມເປັນສ່ວນຕົວນີ້ເປັນແຕ່ລະໄລຍະ. ເມື່ອທ່ານຕົກລົງເຫັນດີເນື້ອໃນທັງໝົດຂອງນະໂຍບາຍ ຄວາມເປັນສ່ວນຕົວສະບັບນີ້, ຖືວ່າທ່ານໄດ້ຕົກລົງເຫັນດີ ແລະ ຮັບຮອງເອົາເນື້ອໃນທັງໝົດຂອງນະໂຍບາຍຄວາມເປັນສ່ວນຕົວນີ້ເປັນທີ່ຮຽບຮ້ອຍແລ້ວ, ນະໂຍບາຍຄວາມເປັນສ່ວນຕົວສະບັບນີ້ເປັນສ່ວນໜຶ່ງຂອງສັນຍາ ການໃຊ້ບໍລິການ GoLaos
        </div>
        <h3># ຂອບເຂດການນໍາໃຊ້:</h3>
        <div class="letter">
          a) ໃນເວລາທ່ານໄດ້ລົງທະບຽນບັນຊີຂອງ GoLaos ນີ້, ທ່ານຕ້ອງສະໜອງຂໍ້ມູນສ່ວນຕົວຂອງທ່ານຕາມຂໍ້ກໍານົດຂອງ GoLaos ເພື່ອດໍາເນີນການລົງທະບຽນ.
        </div>
        <div class="letter1 letter">
          b) ໃນເວລາທ່ານໄດ້ນໍາໃຊ້ການບໍລິການເຄື່ອຂ່າຍ GoLaos ຫຼື ເຂົ້າເຖິງເວັບໄຊສ ຂອງແພຣດຟອມ GoLaos ນີ້, ທາງ GoLaos ຈະຮັບຮອງ ແລະ ບັນທຶກຂໍ້ມູນຂອງທ່ານໂດຍອັດຕະໂນມັດ, ລວມທັງແຕ່ບໍ່ຈໍາກັດສະເພາະແຕ່ທີ່ຢູ່ IP, ປະເພດບຼາວເຊີ(Browser), ຂໍ້ມູນເຊັ່ນວ່າ: ພາສາການນໍາໃຊ້, ວັນທີ ແລະ ເວລາທີ່ເຂົ້າເບິ່ງ, ລັກສະນະຂອງຊ໋ອບແວຣ ແລະ ຮາດແວຣ ບັນທືກໜ້າເວັບ ທີ່ທ່ານຕ້ອງການຊອກຫາໃນເວັບໄຊຕ່າງໆ.
        </div>
        <div class="letter1 letter">
          c) GoLaos ໄດ້ຮັບຂໍ້ມູນສ່ວນຕົວຂອງຜູ້ໃຊ້ໝູ່ຮ່ວມງານດ້ານທຸລະກິດໂດຍຊ່ອງທາງທີ່ຖືກຕ້ອງຕາມລະບຽບກົດໝາຍ.
        </div>
        <h3># ທ່ານຮັບຮູ້ ແລະ ຕົກລົງເຫັນດີ: ຂໍ້ມູນຄືດັ່ງລຸ່ມນີ້ຈະບໍ່ລວມເຂົ້າໃນນະໂຍບາຍທີ່ຄວາມເປັນສ່ວນຕົວ.</h3>
        <div class="letter1 letter">
          a) ຂໍ້ມູນ ຫຼື ຄຳສຳຄັນ ທີ່ທ່ານໄດ້ປ້ອນເຂົ້າໃນເວລາຄົ້ນຫາຂໍ້ມູນຢູ່ອິນເຕີເນັດບຼາວເຊີຂອງ GoLaos ນີ້.
        </div>
        <div class="letter1 letter">
          b) ຂໍ້ມູນທີ່ກ່ຽວຂ້ອງ ແລະ ຂໍ້ມູນທີ່ເກັບກຳໂດຍ GoLaos ທີ່ທ່ານໄດ້ເຜີຍແຜ່ລົງໃນ GoLaos, ລວມທັງບໍ່ຈໍາກັດສະເພາະແຕ່ຂໍ້ມູນທີ່ກ່ຽວກັບການເຂົ້າຮ່ວມກິດຈະກໍາ, ການຊື້-ຂາຍ ແລະ ການຕີລາຄາ ອື່ນໆ.
        </div>
        <div class="letter1 letter">
          c) ການກະທໍາທີ່ລະເມີດລະບຽບກົດໝາຍ ຫຼື ກົດລະບຽບຂອງ GoLaos ແລະ ມາດຕາການທີ່ GoLaos ໃຊ້ກັບທ່ານ.
        </div>
        <h3># ການນໍາໃຊ້ຂໍ້ມູນ:</h3>
        <div class="letter letter1">
          a) GoLaos ຈະບໍ່ສະໜອງ, ການຊື້ຂາຍ, ໃຫ້ເຊົ່າ, ແບ່ງປັນ ຫຼື ເປີດເຜີຍຂໍ້ມູນສ່ວນຕົວຂອງທ່ານໃຫ້ແກ່ບຸກຄົນທີສາມທີ່ບໍ່ກ່ຽວຂ້ອງ, ເວັ້ນເສຍແຕ່ ກໍລະນີໄດ້ຮັບອະນຸຍາດຈາກທ່ານ ຫຼື ເປັນກໍລະນີທີ່ບຸກຄົນທີສາມ ແລະ GoLaos (ລວມບັນດາບໍລິສັດທີ່ກ່ຽວກັບ GoLaos) ເປັນສ່ວນບຸກຄົນ ຫຼື ຮ່ວມກັນເພື່ອໃຫ້ການບໍລິການໃຫ້ແກ່ທ່ານ ແລະ ຫຼັງຈາກສໍາເລັດການບໍລິການແລ້ວທາງ GoLaos ຈະກໍານົດຫ້າມບໍ່ໃຫ້ເຂົ້າເຖິງຂໍ້ມູນຕ່າງໆ, ລວມເຖິງຂໍ້ມູນທີ່ເຄີຍເຂົ້າໄດ້.
        </div>
        <div class="letter letter1">
          b) ທາງ GoLaos ບໍ່ອະນຸຍາດໃຫ້ບຸກຄົນທີສາມລວບລວມ, ຮຽບຮຽງ, ຊື້ຂາຍ ຫຼື ສະໜອງຂໍ້ມູນສ່ວນຕົວຂອງທ່ານ. ຖ້າຜູ້ໃຊ້ແພລດຟອມ GoLaos ມີສ່ວນຮ່ວມໃນກິດຈະກໍາຂ້າງເທິງ, ເມື່ອຄົ້ນພົບແລ້ວ, GoLaos ມີສິດຢຸດຕິສັນຍາການບໍລິການກັບຜູ້ໃຊ້ໄດ້ທັນທີ.
        </div>
        <div class="letter letter1">
          c) ອີງຕາມຄວາມຕ້ອງການຂອງຜູ້ໃຊ້ບໍລິການ, ທາງ GoLaos ສາມາດສະໜອງຂໍ້ມູນທີ່ທ່ານສົນໃຈໄດ້ໂດຍນໍາໃຊ້ຂໍ້ມູນສ່ວນຕົວຂອງທ່ານ,ລວມທັງຂໍ້ມູນທີ່ກ່ຽວກັບສິນຄ້າ ແລະ ການບໍລິການ ຫຼື ເປັນຂໍ້ມູນສ່ວນທີ່ເປີດເຜີຍໄດ້ຂອງໝູ່ເພື່ອນຮ່ວມງານຂອງ GoLaos ເພື່ອສະດວກໃຫ້ເຂົາສົ່ງຂໍ້ມູນທີ່ກ່ຽວກັບປະເພດສິນຄ້າ ຫຼື ການບໍລິການໃຫ້ກັບທ່ານ(ສໍາລັບສະໜອງຂໍ້ມູນຂອງທ່ານໃຫ້ໝູ່ເພື່ອນຮ່ວມງານນັ້ນ ຕ້ອງຮັບອະນຸຍາດຈາກທ່ານກ່ອນ).
        </div>
        <div class="letter letter1">
          # ການເປີດເຜີຍຂໍ້ມູນພາຍໃຕ້ສະພາບການຄືດັ່ງລຸ່ມນີ້, GoLaos ຈະເປິດເຜີຍຂໍ້ມູນສ່ວນຕົວຂອງທ່ານທັງໝົດ ຫຼື ບາງສ່ວນ ຕາມຈຸດປະສົງສ່ວນບຸກຄົນຂອງທ່ານ ຫຼື ອີງຕາມຂໍ້ກໍານົດຂອງລະບຽບກົດໝາຍ .
        </div>
        <div class="letter letter1">
          a) ໄດ້ປຶກສາຫາລື ແລະ ໄດ້ຮັບອະນຸຍາດຈາກທ່ານກ່ອນຈະເປີດເຜີຍໃຫ້ແກ່ບຸກຄົນທີສາມ.
        </div>
        <div class="letter letter1">
          b) ອີງຕາມຄວາມຕ້ອງການຂອງທ່ານເພື່ອຈະສະໜອງຂໍ້ມູນທີ່ກ່ຽວກັບສິນຄ້າ ແລະ ການບໍລິການໃຫ້ທ່ານ, ມີຄວາມຈໍາເປັນຕ້ອງສະໜອງຂໍ້ມູນສ່ວນຕົວຂອງທ່ານໃຫ້ບຸກຄົນທີສາມ.
        </div>
        <div class="letter letter1">
          c) ອີງຕາມຂໍ້ກໍານົດຂອງລະບຽບກົດໝາຍ ຫຼື ອີງຕາມຄໍາສັ່ງຂອງກະຊວງຍຸດຕິທໍາ ຫຼື ອົງການພັກລັດທີ່ກ່ຽວຂ້ອງ, ຕ້ອງເປີດເຜີຍຂໍ້ມູນຂອງທ່ານໃຫ້ບຸກຄົນທີສາມ ຫຼື ຂະແໜງການທີ່ກ່ຽວຂ້ອງຂອງລັດ.
        </div>
        <div class="letter letter1">
          d) ຖ້າຫາກທ່ານຜິດລະບຽບກົດໝາຍ ຫຼື ລະເມີດສັນຍາບໍລິການ ຫຼື ກົດລະບຽບຂອງ GoLaos ຈໍາເປັນຕ້ອງເປີດເຜີຍໃຫ້ບຸກຄົນທີສາມ.
        </div>
        <div class="letter letter1">
          e) ກໍລະນີທ່ານຖືກຮ້ອງທຸກກ່ຽວກັບຊັບສິນທາງປັນຍາ, ອີງຕາມການຮຽກຮ້ອງຂອງຜູ້ຮ້ອງທຸກຈະສະໜອງໃຫ້ຜູ້ຮ້ອງທຸກເພື່ອສະດວກໃນການແກ້ໄຂຂໍ້ຂັດແຍ່ງຂອງທັງສອງຝ່າຍ.
        </div>
        <div class="letter letter1">
          f) ທຸລະກໍາທີ່ສ້າງຂຶ້ນໃນ GoLaos, ຖ້າຫາກຝ່າຍໃດຝ່າຍໜຶ່ງໄດ້ປະຕິບັດພັນທະບາງສ່ວນ ແລະ ສະເໜີໃຫ້ເປີດເຜີຍ ຫຼື ສະໜອງຂໍ້ມູນນັ້ນ GoLaos ມີສິດສະໜອງຂໍ້ມູນທີ່ຈໍາເປັນຄື ເບີໂທຕິດຕໍ່ ຫຼື ຂໍ້ມູນອື່ນໆ ທີ່ຈໍາເປັນໃຫ້ອີກຝ່າຍໜຶ່ງ ເພື່ອຊຸກຍູ້ໃຫ້ໄດ້ເກີດຜົນການຊື້-ຂາຍ ຫຼື ສໍາເລັດໃນການແກ້ໄຂຂໍ້ຂັດແຍ່ງ.
        </div>
        <div class="letter letter1">
          g) ການເປີດເຜີຍຂໍ້ມູນອື່ນທີ່ GoLaos ເຫັນວ່າເໝາະສົມຕາມກົດໝາຍ, ລະບຽບການ ຫຼື ນະໂຍບາຍ ຂອງເວັບໄຊທ
        </div>
        <div class="letter letter1">
          ການເກັບຮັກສາ ແລະ ແລກປ່ຽນຂໍ້ມູນຂ່າວສານ, ຂໍ້ມູນຂອງທ່ານເພື່ອບັນທຶກໄວ້ໃນ GoLaos ນີ້ຈະຖືກເກັບຢູ່ໃນເຊີບເວີຂອງ GoLaos, ຂໍ້ມູນດັ່ງກ່າວອາດຈະຖືກສົ່ງໄປຮອດປະເທດ ຫຼື ຂອບເຂດຂອງທ່ານ ຫຼື ອາດຈະເຂົ້າເຖິງໄດ້ໃນຕ່າງປະເທດທີ່ GoLaos ສາມາດນໍາໃຊ້ ແລະ ເຂົ້າເຖິງໄດ້ ເພື່ອໃຫ້ເຂົ້າເບິ່ງ, ບັນທຶກໄວ້ ຫຼື ເຜີຍແຜ່ຢູ່ຕ່າງປະເທດ.
        </div>
        <h3># ການນໍາໃຊ້Cookie</h3>
        <div class="letter1 letter">
          a) ຖ້າຫາກທ່ານປະຕິເສດທີ່ຈະບໍ່ຍອມຮັບເອົາ Cookie, GoLaos ຈະຕັ້ງຄ່າໃນຄອມພິວເຕີ ຫຼື ເລືອກໃຊ້ Cookie ເພື່ອສະດວກໃຫ້ທ່ານເຂົ້າສູ່ລະບົບ ຫຼື ນໍາໃຊ້ຟັງຊັນ ແລະ ການບໍລິການຂອງ Cookie ທີ່ຂຶ້ນກັບ GoLaos ນີ້, GoLaos ໄດ້ນໍາໃຊ້ Cookie ສາມາດສະໜອງການບໍລິການໄດ້ຢ່າງຄົບວົງຈອນລວມການບໍລິການດ້ານໂຄສະນາ.
        </div>
        <div class="letter1 letter">
          b) ທ່ານມີສິດຮັບຮອງ ຫຼື ປະຕິເສດຍອມຮັບເອົາ Cookie, ທ່ານສາມາດປະຕິເສດ Cookie ໄດ້ໂດຍຜ່ານວິທີການດັດແກ້ຕັ້ງຄ່າບຼາວເຊີຂອງທ່ານ, ຖ້າຫາກທ່ານເລືອກປະຕິເສດຮັບຮອງເອົາ Cookie, ທ່ານຈະບໍ່ສາມາດເຂົ້າລະບົບ ຫຼື ນໍາໃຊ້ການບໍລິການຂອງເວັບ ແລະ ຟັງຊັນອື່ນຂອງ GoLaos ນີ້, ເນື່ອງຈາກແອັບນີ້ອິງໃສ່ Cookie,
        </div>
        <div class="letter letter1">
          C) ຂໍ້ມູນທີ່ກ່ຽວຂ້ອງທີ່ໄດ້ຮັບຜ່ານ Cookie ທີ່ກໍານົດໄວ້ໂດຍ GoLaos ຈະນໍາໃຊ້ກັບນະໂຍບາຍນີ້
        </div>
        <h3># ຄວາມປອດໄພຂອງຂໍ້ມູນ</h3>
        <div class="letter letter1">
          a) ບັນຊີຂອງ GoLaos ນີ້, ມີຟັງຊັນທີ່ປົກປ້ອງຄວາມປອດໄພ, ກະລຸນາຮັກສາບັນຊີ ແລະ ລະຫັດຜ່ານໃຫ້ດີ. ທາງ GoLaos ຈະມີມາດຕາການເພີ່ມຕໍ່ລະຫັດຂອງຜູ້ນໍາໃຊ້ ເພື່ອຮັບປະກັນຂໍ້ມູນຂອງທ່ານບໍ່ເປີດເຜີຍ ຫຼື ເສຍລັບ, ບໍ່ຖືກໃຊ້ໃນເປົ້າໝາຍອື່ນ ແລະ ຖືກດັດແກ້. ເຖິງວ່າຈະມີມາດຕາການຕາມຂ້າງເຖິງນີ້ກໍ່ຕາມ, ຕ້ອງໃຫ້ທ່ານລະມັດລະວັງເພີ້ມເຕີ່ມ, ເນື່ອງຈາກວ່າຂໍ້ມູນໃນອິນເຕີເນັດນີ້ບໍ່ມີມາດຕາການສົມບູນທີ່ກ່ຽວກັບຄວາມປອດໄພ.
        </div>
        <div class="letter letter1">
          b) ໃນເວລາດໍາເນີນທຸລະກຳໂດຍນໍາໃຊ້ເຄື່ອຂ່າຍ GoLaos ນີ້, ທ່ານຫລີກລ້ຽງບໍ່ໄດ້ວ່າຕ້ອງສະໜອງຂໍ້ມູນຂອງທ່ານໃຫ້ແກ່ຄູ່ຮ່ວມມື ຫຼື ຜູ້ອື່ນທີ່ກ່ຽວຂ້ອງ.
        </div>
        <h3>
          # ການປ່ຽນແປງຂອງນະໂຍບາຍກ່ຽວກັບຂໍ້ມູນສ່ວນຕົວນີ້.
        </h3>
        <div class="letter letter1">
          a) ຖ້າຫາກມີການປ່ຽນແປງນະໂຍບາຍຄວາມເປັນສ່ວນຕົວ, ພວກເຮົາຈະປະກາດການປ່ຽນແປງເຫຼົ່ານີ້ໃນນະໂຍບາຍນີ້, ຢູ່ໃນເວັບໄຊທ໌ຂອງບໍລິສັດຂອງພວກເຮົາ, ແລະ ບ່ອນທີ່ພວກເຮົາຖືວ່າ ເໝາະສົມ, ເພື່ອໃຫ້ທ່ານເຂົ້າໃຈວິທີທີ່ພວກເຮົາເກັບກຳ ແລະ ນຳໃຊ້ຂໍ້ມູນສ່ວນຕົວຂອງທ່ານ, ຜູ້ໃດກໍ່ສາມາດເຂົ້າເຖິງສິ່ງນີ້ໄດ້ ແລະ ພາຍໃຕ້ສະຖານະການໃດທີ່ພວກເຮົາຈະເປີດເຜີຍຂໍ້ມູນນີ້.
        </div>
        <div class="letter letter1">
          b) ບໍລິສັດພວກເຮົາຂໍສະຫງວນສິດໃນດັດແປງນະໂຍບາຍຄວາມເປັນສ່ວນຕົວສະບັບນີ້ໃນເວລາໃດກໍ່ຕາມ, ສະນັ້ນໃຫ້ກະລຸນາກວດສອບເລື້ອຍໆ, ຖ້າຫາກມີການປ່ຽນແປງນະໂຍບາຍນີ້, ທາງບໍລິສັດຈະອອກແຈ້ງການລົງໃນເວັບໄຊຂອງບໍລິສັດ.
        </div>
        <div class="letter letter1">
          c) ຢ່າເປີດເຜີຍຂໍ້ມູນສ່ວນຕົວຂອງທ່ານ, ເຊັ່ນວ່າ: ຂໍ້ມູນຕິດຕໍ່ ຫຼື ທີ່ຢູ່ທາງໄປສະນີໃຫ້ແກ່ບຸກຄົນທີສາມ. ກະລຸນາຮັກສາຂໍ້ມູນຂອງທ່ານໃຫ້ຖືກຕ້ອງ ແລະ ສະໜອງໃຫ້ຜູ້ອື່ນກໍລະນີທີ່ຈໍາເປັນ. ຖ້າທ່ານຫາກເຫັນວ່າຂໍ້ມູນສ່ວນຕົວຂອງຕົນຮົ່ວໄຫຼ, ໂດຍສະເພາະແມ່ນບັນຊີ ແລະ ລະຫັດຜ່ານຂອງ GoLaos, ກະລຸນາຕິດຕໍ່ຫາສູນບໍລິການຂອງ GoLaos ໂດຍດ່ວນ ເພື່ອໃຫ້ GoLaos ສາມາດນໍາໃຊ້ມາດຕາການທີ່ຈໍາເປັນ,ຮັບປະກັນຄວາມປອດໄພ.
        </div>
      </div>
    </my-scroll>
  </div>
</template>

<script>

import MyScroll from '../../components/MyScroll'
export default {
  name: 'newLifeZh',
  components: {
    MyScroll
  },
  setup () {
    // const { ctx } = getCurrentInstance()
    // console.log(ctx.$root.$route.query.lang)
    return {
      txt1: ''
    }
  }
}
</script>

<style scoped lang="scss">
@mixin flex-box-center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.new-life {
  width: 100%;
  .scroll {
    width: 100%;
    height: 100%;
    padding: 0px 16px;
    position: absolute;
    touch-action: none;
    overflow: hidden;
    -webkit-overflow-scrolling: touch;
    &::-webkit-scrollbar {
      width: 0px;
    }
    header {
      width: 100%;
      margin-top: 25px;
      margin-bottom: 35px;
      height: 28px;
      padding: 0px 16px;
      overflow: hidden;
      opacity: 1;
      font-size: 20px;
      font-weight: bold;
      font-family: Phetsarath OT;
      color: #333333;
      @include flex-box-center;
    }
    .scroll-content {
      position: absolute;
      top: 0px;
      padding: 0px 16px;
      left: 0px;
      h3 {
        padding: 13px 0px 0px;
        margin-bottom: 12px;
        // height: 25px;
        opacity: 1;
        font-size: 15px;
        font-weight: bold;
        font-family: Phetsarath OT;
        text-align: left;
        color: #333333;
        // line-height: 40px;
      }
      span {
        // font-weight: 600;
      }
      .letter {
        text-align: left;
        opacity: 1;
        font-size: 15px;
        font-weight: 400;
        font-family: Phetsarath OT;
        line-height: 25px;
        // word-break: keep-all;
        color: #333333;
      }
      .letter1 {
        margin-top: 12px;
      }
    }
  }
}
</style>
